import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbsProps {
  items: Crumb[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="面包屑导航" className="text-xs text-foreground-500">
      <ol className="flex flex-wrap items-center gap-1">
        <li className="flex items-center gap-1">
          <Link to="/" className="transition-colors hover:text-primary-600">
            首页
          </Link>
        </li>
        {items.map((item) => (
          <li key={item.label} className="flex items-center gap-1">
            <i className="ri-arrow-right-s-line text-foreground-400" />
            {item.to ? (
              <Link to={item.to} className="transition-colors hover:text-primary-600">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}